import { render } from "./ApiPostLoadMaster.vue?vue&type=template&id=665bddf9&ts=true"
import script from "./ApiPostLoadMaster.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApiPostLoadMaster.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/api/ApiPostLoadMaster.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "665bddf9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('665bddf9', __exports__)) {
    api.reload('665bddf9', __exports__)
  }
  
  module.hot.accept("./ApiPostLoadMaster.vue?vue&type=template&id=665bddf9&ts=true", () => {
    api.rerender('665bddf9', render)
  })

}


export default __exports__